import { api } from '@/api';
import { API_URL } from '@/dtos';

import { ContributionActivityStatus } from '../types';

interface Props {
  contributionId?: string;
  statuses?: ContributionActivityStatus[];
  taxYears?: string[];
  planCodes?: string[];
  employeeName?: string;
}

const useExportContributionActivityReportQuery = () => (props: Props) =>
  api.get(API_URL.CONTRIBUTIONS_CONTRIBUTION_REQUESTS_ACTIVITY_CSV_REPORT, {
    params: {
      ...(props?.contributionId ? { contribution_id: props?.contributionId } : {}),
      ...(props?.statuses?.length ? { statuses: props?.statuses.join(',') } : {}),
      ...(props?.taxYears?.length ? { tax_years: props?.taxYears.join(',') } : {}),
      ...(props?.planCodes?.length ? { plan_codes: props?.planCodes.join(',') } : {}),
      ...(props?.employeeName ? { employee_name: props?.employeeName } : {}),
    },
  });

export default useExportContributionActivityReportQuery;
